// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.videoInline = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			$html: $('html'),
			link: '.video-inline__link',
			active: 'video__inline--active'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		};

		// Bind events
		methods.events = function() {

			$context.each(function() {
				var $this = $(this),
					$videoLink = $this.find(settings.link),
					videoUrl = $videoLink.attr('href'),
					videoId = '',
					rel = 0,
					showinfo = 0,
					modestbranding = 1,
					color = 'white';

				if (videoUrl.indexOf('embed') !== -1) {
					videoId = videoUrl.split('embed/')[1];
				} else if (videoUrl.indexOf('v=') !== -1) {
					videoId = videoUrl.split('v=')[1];

					var ampersandPosition = videoId.indexOf('&');

					if (ampersandPosition != -1) {
						videoId = videoId.substring(0, ampersandPosition);
					}
				} else if (videoUrl.indexOf('youtu.be') !== -1) {
					videoId = videoUrl.split('youtu.be/')[1];
				} else if (videoUrl.length < 15) {
					videoId = videoUrl;
				}


				$videoLink.attr('href', 'https://www.youtube.com/watch?v=' + videoId);

				if (typeof $videoLink.data('rel') !== 'undefined' && $videoLink.data('rel') !== '') {
					rel = $videoLink.data('rel');
				}

				if (typeof $videoLink.data('showinfo') !== 'undefined' && $videoLink.data('showinfo') !== '') {
					showinfo = $videoLink.data('showinfo');
				}

				if (typeof $videoLink.data('modestbranding') !== 'undefined' && $videoLink.data('modestbranding') !== '') {
					modestbranding = $videoLink.data('modestbranding');
				}

				if (typeof $videoLink.data('color') !== 'undefined' && $videoLink.data('color') !== '') {
					color = $videoLink.data('color');
				}

				// Temporarily commenting this out as poster image is needed. Needs to be re-visited for better mobile option though.
				//if (settings.$html.hasClass('is-mobile') || settings.$html.hasClass('is-tablet')) {
					//$this.html('<iframe src="https://www.youtube.com/embed/'+ videoId +'?rel='+ rel +'&autoplay=1&showinfo='+ showinfo +'&modestbranding='+ modestbranding +'&color='+ color +'" width="320" height="240" frameborder="0" allowfullscreen="true">');
					//$this.addClass(settings.active);
				//}

				$videoLink.on('click', function(event) {
					event.preventDefault();

					$this.html('<iframe src="https://www.youtube.com/embed/'+ videoId +'?rel='+ rel +'&autoplay=1&showinfo='+ showinfo +'&modestbranding='+ modestbranding +'&color='+ color +'" width="320" height="240" frameborder="0" allowfullscreen="true">');
					$this.addClass(settings.active);
				});
			});
		};

		methods.initContext = function() {
			methods.setCurrentSettings();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
	};

	if ($('.video__inline').length) {
		$('.video__inline').videoInline();
	}

}(jQuery));
